module.exports = __webpack_public_path__ + "img/02.73f8859a.png";